import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { PanicProvider } from "./contexts/PanicContext";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import ScenarioFlow from "./pages/ScenarioFlow";
import Results from "./pages/Results";
import Profile from "./pages/Profile";
import About from "./pages/About";
import Resources from "./pages/Resources";
import Conditions from "./pages/Conditions";
import DisclosureCard from "./pages/DisclosureCard";
import SharedCard from "./pages/SharedCard";
import Journal from "./pages/Journal";
import SymptomTracker from "./pages/SymptomTracker";
import SkillsHub from "./pages/SkillsHub";
import SkillExercise from "./pages/SkillExercise";
import Insights from "./pages/Insights";
import Medications from "./pages/Medications";
import HealthcareExport from "./pages/HealthcareExport";
import PanicOverlay from "./components/PanicOverlay";
import BottomNav from "./components/BottomNav";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PanicProvider>
          <div className="min-h-screen">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/about" element={<About />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/conditions" element={<Conditions />} />
              <Route path="/disclosure-card/:conditionId" element={<DisclosureCard />} />
              <Route path="/share/:shareId" element={<SharedCard />} />
              <Route
                path="/dashboard"
                element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
              />
              <Route
                path="/scenario/:scenarioType"
                element={<ProtectedRoute><ScenarioFlow /></ProtectedRoute>}
              />
              <Route
                path="/results/:sessionId"
                element={<ProtectedRoute><Results /></ProtectedRoute>}
              />
              <Route
                path="/profile"
                element={<ProtectedRoute><Profile /></ProtectedRoute>}
              />
              <Route
                path="/journal"
                element={<ProtectedRoute><Journal /></ProtectedRoute>}
              />
              <Route
                path="/symptoms"
                element={<ProtectedRoute><SymptomTracker /></ProtectedRoute>}
              />
              <Route
                path="/skills"
                element={<ProtectedRoute><SkillsHub /></ProtectedRoute>}
              />
              <Route
                path="/skills/:skillId"
                element={<ProtectedRoute><SkillExercise /></ProtectedRoute>}
              />
              <Route
                path="/insights"
                element={<ProtectedRoute><Insights /></ProtectedRoute>}
              />
              <Route
                path="/medications"
                element={<ProtectedRoute><Medications /></ProtectedRoute>}
              />
              <Route
                path="/healthcare-export"
                element={<ProtectedRoute><HealthcareExport /></ProtectedRoute>}
              />
            </Routes>
            <PanicOverlay />
            <BottomNav />
            <Toaster position="top-center" richColors />
          </div>
        </PanicProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
